import Apify from '@module/apify';

export default Apify({
  getAssetUploadPresignedForm: {
    path: '/api/v4/user-uploaded-assets/presigned-form',
  },

  allocateAsset: {
    path: '/api/v4/user-uploaded-assets/preallocate',
    method: 'POST',
  },

  allocateCuratedImage: {
    path: '/api/v4/user-uploaded-assets/preallocate-curated',
    method: 'POST',
  },

  getSubscriptionPricing: {
    path: '/api/v4/subscriptions/pricing',
    method: 'GET',
  },

  getSeatsPricing: {
    path: '/api/v4/subscriptions/seats',
    method: 'GET',
  },
});
